import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import logo from '../assets/logo.png';

const useStyles = makeStyles({
  container: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logo: {
    width: 300,
  },
});

export default function SplashScreen() {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <img src={logo} className={classes.logo} alt="Mirage ID" />
    </div>
  );
}
